import { useQuery } from "@tanstack/react-query";
import type { TWorkspace } from "../types";
import { getWorkspace } from "../services";

// ── Cache keys (imported by mutation hooks — never redefine) ──────────────────
export const workspaceKeys = {
  detail: (workspaceId: string) => ["workspace", workspaceId] as const,
};

export const useGetWorkspace = (
  workspaceId: string,
  options?: { enabled?: boolean },
) => {
  return useQuery<TWorkspace>({
    queryKey: workspaceKeys.detail(workspaceId),
    queryFn: ({ signal }) => getWorkspace(workspaceId, signal),
    enabled: options?.enabled ?? !!workspaceId,
    retry: 1,
    staleTime: 1000 * 60 * 2,
  });
};
